<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Sitios</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Basico</li>
                  <li class="breadcrumb-item active">Sitios</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-3 pt-2 pb-2">
                <h5 class="mb-0">Formulario {{ accion }} Sitios</h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="tab-Geocercas"
                    data-toggle="tab"
                    href="#Geocercas"
                    v-if="form.id"
                    >Geocercas</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="codigo">Código Alterno</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="codigo"
                            v-model="form.codigo"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="nombre">Nombre</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="nombre"
                            v-model="form.nombre"
                            :class="
                              $v.form.nombre.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="sigla">Sigla</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="sigla"
                            v-model="form.sigla"
                            :class="
                              $v.form.sigla.$invalid ? 'is-invalid' : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="ciudad">Ciudad</label>
                          <v-select
                            :class="[
                              $store.getters.getDarkMode ? 'dark-vselect' : '',
                              $v.form.ciudad_id.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                              'form-control form-control-sm p-0',
                            ]"
                            v-model="ciudad"
                            label="nombre"
                            :options="listasForms.ciudades"
                            placeholder="Ciudades"
                            @input="getSelectCiudades()"
                          ></v-select>
                        </div>
                      </div>
                      <div class="col-md-3" v-if="ciudad.id">
                        <div class="form-group">
                          <label for="ciudad">Departamento</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="departamento"
                            v-model="ciudad.departamento.descripcion"
                            readonly
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="bloque">Bloque</label>
                          <v-select
                            v-model="bloque"
                            class="form-control form-control-sm p-0"
                            :class="[
                              $store.getters.getDarkMode ? 'dark-vselect' : '',
                              $v.form.bloque_id.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                            ]"
                            label="nombre"
                            :options="listasForms.bloques"
                            placeholder="Bloques"
                            @input="getSelectBloques()"
                          ></v-select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="dirreccion">Dirección</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="dirreccion"
                            v-model="form.dirreccion"
                            :class="
                              $v.form.dirreccion.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="latitud">Latitud</label>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="latitud"
                            v-model="form.latitud"
                            :class="
                              $v.form.latitud.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="longitud">Longitud</label>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="longitud"
                            v-model="form.longitud"
                            :class="
                              $v.form.longitud.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="kilometraje_postulacion"
                            >Kilometraje postulación</label
                          >
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="kilometraje_postulacion"
                            v-model="form.kilometraje_postulacion"
                            :class="
                              $v.form.kilometraje_postulacion.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="km_postulacion_add"
                            >Km postulación adicional</label
                          >
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="km_postulacion_add"
                            v-model="form.km_postulacion_add"
                            :class="
                              $v.form.km_postulacion_add.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="tipo_sitio">Tipo de sitio</label>
                          <select
                            class="form-control form-control-sm"
                            v-model="form.tipo_sitio"
                            :class="
                              $v.form.tipo_sitio.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          >
                            <option value="">Seleccione...</option>
                            <option
                              v-for="tipo_sitio in listasForms.tipo_sitios"
                              :key="tipo_sitio.numeracion"
                              :value="tipo_sitio.numeracion"
                            >
                              {{ tipo_sitio.descripcion }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="cargues_hora">Cargues por hora</label>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="cargues_hora"
                            v-model="form.cargues_hora"
                            :class="
                              $v.form.cargues_hora.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="hora_inicial">Hora inicial Citas</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="hora_inicial"
                            v-model="form.hora_inicial"
                            :class="
                              $v.form.hora_inicial.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                            v-mask="{
                              mask: '99:99',
                              hourFormat: '24',
                            }"
                            @input="validaHoras()"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="hora_final">Hora final Citas</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="hora_final"
                            :class="
                              $v.form.hora_final.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                            v-mask="{
                              mask: '99:99',
                              hourFormat: '24',
                            }"
                            v-model="form.hora_final"
                            @input="validaHoras()"
                          />
                        </div>
                      </div>
                    </div>
                    <SitioProcesosInspecciones v-if="form.id" />
                  </div>
                </div>
                <div class="tab-pane fade" id="Geocercas" v-if="form.id">
                  <div class="card-body">
                    <SitioGeocerca v-if="form.id" />
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <button
                    class="btn bg-primary col-md-1"
                    v-show="!$v.form.$invalid"
                    v-if="$store.getters.can('cs.sitios.save')"
                    @click="save()"
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, helpers } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import SitioGeocerca from "./SitioGeocerca.vue";
import SitioProcesosInspecciones from "./SitioProcesosInspecciones.vue";
import Loading from "../../../../components/Loading";
const timeFormat = helpers.regex(
  "timeFormat",
  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/,
);

export default {
  name: "CsSitioForm",
  components: {
    vSelect,
    SitioProcesosInspecciones,
    SitioGeocerca,
    Loading,
  },
  data() {
    return {
      cargando: false,
      form: {
        ciudad_id: null,
        codigo: null,
        nombre: null,
        sigla: null,
        bloque_id: null,
        dirreccion: null,
        latitud: null,
        longitud: null,
        kilometraje_postulacion: null,
        km_postulacion_add: null,
        tipo_sitio: null,
        cargues_hora: null,
        hora_inicial: null,
        hora_final: null,
        pais_id: 1,
      },
      ciudad: {},
      bloque: {},
      accion: "",
      metodo: "",
      listasForms: {
        ciudades: [],
        tipo_sitios: [],
      },
      modal: {
        title: "",
        accion: "",
      },
    };
  },

  validations: {
    form: {
      nombre: {
        required,
      },
      sigla: {
        required,
      },
      ciudad_id: {
        required,
      },
      bloque_id: {
        required,
      },
      dirreccion: {
        required,
      },
      latitud: {
        required,
      },
      longitud: {
        required,
      },
      kilometraje_postulacion: {
        required,
      },
      km_postulacion_add: {
        required,
      },
      tipo_sitio: {
        required,
      },
      cargues_hora: {
        required,
      },
      hora_inicial: {
        required,
        timeFormat,
      },
      hora_final: {
        required,
        timeFormat,
      },
    },
  },
  methods: {
    getIndex() {
      this.accion = this.$route.params.accion;
      if (this.$route.params.accion == "Editar") {
        this.form = this.$route.params.data_edit;
        this.metodo = "PUT";
        this.ciudad = this.form.ciudad.nombre;
        this.bloque = this.form.bloque;
      } else {
        this.metodo = "POST";
      }
    },

    getTipoSitios() {
      axios.get("/api/lista/18").then((response) => {
        this.listasForms.tipo_sitios = response.data;
      });
    },

    getSelectCiudades() {
      this.form.ciudad_id = null;
      if (this.ciudad) {
        this.form.ciudad_id = this.ciudad.id;
        this.form.departamento_id = this.ciudad.departamento_id ?? null;
      }
    },

    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasForms.ciudades = response.data;
      });
    },

    getSelectBloques() {
      this.form.bloque_id = null;
      if (this.bloque) {
        this.form.bloque_id = this.bloque.id;
      }
    },

    getBloques() {
      axios.get("/api/cs/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    validaHoras() {
      if (this.form.hora_inicial && this.form.hora_final) {
        if (this.form.hora_inicial > this.form.hora_final) {
          this.form.hora_final = null;
          this.$swal({
            icon: "error",
            title: `La hora inicial no puede ser mayor a la hora final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },
    save() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        axios({
          method: this.metodo,
          url: "/api/cs/sitios",
          data: this.form,
        })
          .then((response) => {
            this.cargando = false;
            this.form = response.data;
            this.accion = "Editar";
            this.$swal({
              icon: "success",
              title: "El sitio se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    back() {
      return this.$router.replace("/Cs/Sitios");
    },
  },

  beforeMount() {
    this.getCiudades();
    this.getBloques();
    this.getTipoSitios();
  },

  async mounted() {
    this.getIndex();
  },
};
</script>
